/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2024 Palantir.net
 */

(function ($) {

  // Get all poval videos on page
    const povalVideos = (currentLangCode == "en" ? document.querySelectorAll('.poval-video-player') : document.querySelectorAll('.poval-video-player--spanish'));

  if (povalVideos) {
    povalVideos.forEach(povalVideo => {
      // Poval video scope variables
      const mask = povalVideo.querySelector('.poval-video-player__mask');
      const cursor = povalVideo.querySelector('.poval-video-player__cursor');
      const iframe = povalVideo.querySelector('.poval-video-player__media iframe');

      // Get coordinates of mask element and position the cursor
      function positionCursor(e) {
        const rect = mask.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        cursor.style.transform = `translate3d(${x - 62}px, ${y - 62}px, 0)`;
      }

      // Show iframe video on mouseenter of mask element
      function cursorPlayButton() {
        if (window.innerWidth > 900) {
          // Move cursor element based on the users cursor
          mask.addEventListener('mousemove', positionCursor);

          // Mouseenter triggers
          mask.addEventListener('mouseenter', () => {
            // Add focused class
            mask.classList.add('focused');
            mask.classList.remove('unfocused');

            if (iframe.src.includes('youtube')) {
              // Autoplay YouTube video with sound muted
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
            }
            if (iframe.src.includes('vimeo')) {
              // Autoplay vimeo video with sound muted
              iframe.contentWindow.postMessage('{"method":"setVolume","value":"0"}', iframe.src);
              iframe.contentWindow.postMessage('{"method":"play"}', iframe.src);
            }
          });

          // Mouseleave triggers
          mask.addEventListener('mouseleave', () => {
            // Remove focused class
            mask.classList.add('unfocused');
            mask.classList.remove('focused');

            if (iframe.src.includes('youtube')) {
              // Pause YouTube video when mouse leaves
              iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }

            if (iframe.src.includes('vimeo')) {
              // Pause Vimeo video when mouse leaves
              iframe.contentWindow.postMessage('{"method":"pause"}', iframe.src);
            }
          });
        }
      }

      // Run cursorPlayButton function on page load
      cursorPlayButton();

      // Reposition mask coordinates on window resize
      window.addEventListener('resize', () => {
        cursorPlayButton();
      });
    });
  }

})(jQuery);
